import { Drawer } from '@templates/index';
import { useUiStore } from '@store/index';
import { TransportPanel } from './TransportPanel';

/**
 * Slide-in drawer with metronome / quantize / record controls. Mirrors
 * the SynthDrawer pattern: dedicated state in uiStore, transparent
 * backdrop so the stage stays visible while the player adjusts tempo.
 */
export function TransportDrawer() {
  const open = useUiStore((s) => s.transportOpen);
  const setOpen = useUiStore((s) => s.setTransportOpen);
  const toggle = useUiStore((s) => s.toggleTransport);

  return (
    <Drawer
      open={open}
      onClose={() => setOpen(false)}
      onToggle={toggle}
      title="Transport"
      width="min(420px, 94vw)"
      backdrop="transparent"
      shortcut="b"
      hint={
        <>
          <kbd>B</kbd> toggle · <kbd>Esc</kbd> close
        </>
      }
    >
      <TransportPanel />
    </Drawer>
  );
}
